module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg15-d1ce10ee1e6f7a84ae99e943694fd4e9.png";